<div class="row g-4">
  <div class="col-12 col-xl-12">
    <mat-card>
      <mat-card-content>
        <h5 class="mb-3">Result form</h5>
        <div class="row g-3">
          <!-- Course Dropdown -->
          <div class="col-12 col-md-6">
            <mat-form-field class="w-100" appearance="fill">
              <mat-label>Course</mat-label>
              <mat-select [(ngModel)]="selectedCourseId" name="course" (selectionChange)="onFiltersChange()">
                <mat-option *ngFor="let course of courseList" [value]="course.id">{{ course.name }}-{{course.crs_code}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <!-- Semester Dropdown -->
          <div class="col-12 col-md-6">
            <mat-form-field class="w-100" appearance="fill">
              <mat-label>Semester</mat-label>
              <mat-select [(ngModel)]="selectedSemesterNumber"  name="semester" (selectionChange)="onFiltersChange()">
                <mat-option *ngFor="let sem of semesterList" [value]="sem.number">{{ sem.name }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <!-- Submit -->
          <!-- <div class="col-12">
            <button (click)="delete_student_based_on_filters(selectedCourseId, selectedSemesterId)" mat-flat-button color="primary" [disabled]="isDeleteDisabled()">Delete</button>
          </div> -->

          <!-- <mat-form-field appearance="outline" class="w-100 mb-3">
            <mat-label>Search students</mat-label>
            <input
              matInput
              [(ngModel)]="searchText"
              (ngModelChange)="applyFilter()"
              placeholder="Search by name, register no, email, or phone"
            />
          </mat-form-field> -->
          <div class="search-wrapper">
            <mat-form-field appearance="outline" class="search-input">
              <mat-label>Search students</mat-label>
              <input
                matInput
                [(ngModel)]="searchText"
                placeholder="Search by name, register no, name"
              />
            </mat-form-field>
          
            <button mat-flat-button color="primary" (click)="applyFilter()" class="search-btn">
              Search
            </button>
            <!-- <button mat-flat-button color="primary" (click)="get_all_results_download()">
              Download Full List
            </button> -->
          </div>
          <button mat-flat-button color="primary" (click)="get_all_results_download()">
            Download Full List
          </button>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>

<mat-card>
    <mat-card-title class="title-center">Result List</mat-card-title>
  
    <div class="outer-scroll-wrapper">
      <div class="inner-scroll-container mat-elevation-z8">
        <table mat-table [dataSource]="results" class="full-width-table">
  
          <!-- Actions -->
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef> Actions </th>
            <td mat-cell *matCellDef="let result">
              <button mat-icon-button [matMenuTriggerFor]="menu">
                <mat-icon><b>⋮</b></mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <!-- <button mat-menu-item (click)="onDelete(result)">
                  <mat-icon>Delete</mat-icon>
                </button> -->
              </mat-menu>
            </td>
          </ng-container>

          <ng-container matColumnDef="sno">
            <th mat-header-cell *matHeaderCellDef> S.No. </th>
            <td mat-cell *matCellDef="let row; let i = index">
              {{ currentPage + i + 1 }}
            </td>
          </ng-container>
  
          <!-- Define columns -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef> Name </th>
            <td mat-cell *matCellDef="let s"> {{ s.name }} </td>
          </ng-container>
  
          <ng-container matColumnDef="surname">
            <th mat-header-cell *matHeaderCellDef> Surname </th>
            <td mat-cell *matCellDef="let s"> {{ s.surname }} </td>
          </ng-container>

          <ng-container matColumnDef="register_no">
            <th mat-header-cell *matHeaderCellDef> Registration No </th>
            <td mat-cell *matCellDef="let s"> {{ s.register_no }} </td>
          </ng-container>

          <ng-container matColumnDef="crs_code">
            <th mat-header-cell *matHeaderCellDef> CRS Code </th>
            <td mat-cell *matCellDef="let s"> {{ s.crs_code }} </td>
          </ng-container>
  
          <ng-container matColumnDef="semester_number">
            <th mat-header-cell *matHeaderCellDef> Semester Number </th>
            <td mat-cell *matCellDef="let s"> {{ s.semester_number }} </td>
          </ng-container>

          <ng-container matColumnDef="scheme_type">
            <th mat-header-cell *matHeaderCellDef>Scheme Type </th>
            <td mat-cell *matCellDef="let s"> {{ s.scheme_type }} </td>
          </ng-container>
  
          <ng-container matColumnDef="exam_month">
            <th mat-header-cell *matHeaderCellDef> Exam Month </th>
            <td mat-cell *matCellDef="let s"> {{ s.exam_month }} </td>
          </ng-container>
  
          <ng-container matColumnDef="result_type">
            <th mat-header-cell *matHeaderCellDef> Result Type </th>
            <td mat-cell *matCellDef="let s"> {{ s.result_type }} </td>
          </ng-container>
  
          <ng-container matColumnDef="ia_sub1">
            <th mat-header-cell *matHeaderCellDef> Ia sub1 </th>
            <td mat-cell *matCellDef="let s"> {{ s.ia_sub1 }} </td>
          </ng-container>
  
          <ng-container matColumnDef="see_sub1">
            <th mat-header-cell *matHeaderCellDef> See Sub1 </th>
            <td mat-cell *matCellDef="let s"> {{ s.see_sub1 }} </td>
          </ng-container>
  
          <ng-container matColumnDef="total_sub1">
            <th mat-header-cell *matHeaderCellDef> Total Sub1 </th>
            <td mat-cell *matCellDef="let s"> {{ s.total_sub1 }} </td>
          </ng-container>
  
          <ng-container matColumnDef="result_sub1">
            <th mat-header-cell *matHeaderCellDef> Result Sub1 </th>
            <td mat-cell *matCellDef="let s"> {{ s.result_sub1 }} </td>
          </ng-container>
  
          <ng-container matColumnDef="ia_sub2">
            <th mat-header-cell *matHeaderCellDef> Ia sub2 </th>
            <td mat-cell *matCellDef="let s"> {{ s.ia_sub2 || '-' }} </td>
          </ng-container>
  
          <ng-container matColumnDef="see_sub2">
            <th mat-header-cell *matHeaderCellDef> See Sub2 </th>
            <td mat-cell *matCellDef="let s"> {{ s.see_sub2 }} </td>
          </ng-container>
  
          <ng-container matColumnDef="total_sub2">
            <th mat-header-cell *matHeaderCellDef> Total Sub2 </th>
            <td mat-cell *matCellDef="let s"> {{ s.total_sub2 }} </td>
          </ng-container>
  
          <ng-container matColumnDef="result_sub2">
            <th mat-header-cell *matHeaderCellDef> Result Sub2 </th>
            <td mat-cell *matCellDef="let s"> {{ s.result_sub2 }} </td>
          </ng-container>

          <ng-container matColumnDef="ia_sub3">
            <th mat-header-cell *matHeaderCellDef> Ia sub3 </th>
            <td mat-cell *matCellDef="let s"> {{ s.ia_sub3 }} </td>
          </ng-container>
  
          <ng-container matColumnDef="see_sub3">
            <th mat-header-cell *matHeaderCellDef> See Sub3 </th>
            <td mat-cell *matCellDef="let s"> {{ s.see_sub3 }} </td>
          </ng-container>
  
          <ng-container matColumnDef="total_sub3">
            <th mat-header-cell *matHeaderCellDef> Total Sub3 </th>
            <td mat-cell *matCellDef="let s"> {{ s.total_sub3 }} </td>
          </ng-container>
  
          <ng-container matColumnDef="result_sub3">
            <th mat-header-cell *matHeaderCellDef> Result Sub3 </th>
            <td mat-cell *matCellDef="let s"> {{ s.result_sub3 }} </td>
          </ng-container>

          <ng-container matColumnDef="ia_sub4">
            <th mat-header-cell *matHeaderCellDef> Ia sub4 </th>
            <td mat-cell *matCellDef="let s"> {{ s.ia_sub4 }} </td>
          </ng-container>
  
          <ng-container matColumnDef="see_sub4">
            <th mat-header-cell *matHeaderCellDef> See Sub4 </th>
            <td mat-cell *matCellDef="let s"> {{ s.see_sub4 }} </td>
          </ng-container>
  
          <ng-container matColumnDef="total_sub4">
            <th mat-header-cell *matHeaderCellDef> Total Sub4 </th>
            <td mat-cell *matCellDef="let s"> {{ s.total_sub4 }} </td>
          </ng-container>
  
          <ng-container matColumnDef="result_sub4">
            <th mat-header-cell *matHeaderCellDef> Result Sub4 </th>
            <td mat-cell *matCellDef="let s"> {{ s.result_sub4 }} </td>
          </ng-container>

          <ng-container matColumnDef="ia_sub5">
            <th mat-header-cell *matHeaderCellDef> Ia sub5 </th>
            <td mat-cell *matCellDef="let s"> {{ s.ia_sub5 }} </td>
          </ng-container>
  
          <ng-container matColumnDef="see_sub5">
            <th mat-header-cell *matHeaderCellDef> See Sub5 </th>
            <td mat-cell *matCellDef="let s"> {{ s.see_sub5 }} </td>
          </ng-container>
  
          <ng-container matColumnDef="total_sub5">
            <th mat-header-cell *matHeaderCellDef> Total Sub5 </th>
            <td mat-cell *matCellDef="let s"> {{ s.total_sub5 }} </td>
          </ng-container>
  
          <ng-container matColumnDef="result_sub5">
            <th mat-header-cell *matHeaderCellDef> Result Sub5 </th>
            <td mat-cell *matCellDef="let s"> {{ s.result_sub5 }} </td>
          </ng-container>

          <ng-container matColumnDef="ia_sub6">
            <th mat-header-cell *matHeaderCellDef> Ia sub6 </th>
            <td mat-cell *matCellDef="let s"> {{ s.ia_sub6 }} </td>
          </ng-container>
  
          <ng-container matColumnDef="see_sub6">
            <th mat-header-cell *matHeaderCellDef> See Sub6 </th>
            <td mat-cell *matCellDef="let s"> {{ s.see_sub6 }} </td>
          </ng-container>
  
          <ng-container matColumnDef="total_sub6">
            <th mat-header-cell *matHeaderCellDef> Total Sub6 </th>
            <td mat-cell *matCellDef="let s"> {{ s.total_sub6 }} </td>
          </ng-container>
  
          <ng-container matColumnDef="result_sub6">
            <th mat-header-cell *matHeaderCellDef> Result Sub6 </th>
            <td mat-cell *matCellDef="let s"> {{ s.result_sub6 }} </td>
          </ng-container>

          <ng-container matColumnDef="ia_sub7">
            <th mat-header-cell *matHeaderCellDef> Ia sub7 </th>
            <td mat-cell *matCellDef="let s"> {{ s.ia_sub7 }} </td>
          </ng-container>
  
          <ng-container matColumnDef="see_sub7">
            <th mat-header-cell *matHeaderCellDef> See Sub7 </th>
            <td mat-cell *matCellDef="let s"> {{ s.see_sub7 }} </td>
          </ng-container>
  
          <ng-container matColumnDef="total_sub7">
            <th mat-header-cell *matHeaderCellDef> Total Sub7 </th>
            <td mat-cell *matCellDef="let s"> {{ s.total_sub7 }} </td>
          </ng-container>
  
          <ng-container matColumnDef="result_sub7">
            <th mat-header-cell *matHeaderCellDef> Result Sub7 </th>
            <td mat-cell *matCellDef="let s"> {{ s.result_sub7 }} </td>
          </ng-container>

          <ng-container matColumnDef="ia_sub8">
            <th mat-header-cell *matHeaderCellDef> Ia sub8 </th>
            <td mat-cell *matCellDef="let s"> {{ s.ia_sub8 }} </td>
          </ng-container>
  
          <ng-container matColumnDef="see_sub8">
            <th mat-header-cell *matHeaderCellDef> See Sub8 </th>
            <td mat-cell *matCellDef="let s"> {{ s.see_sub8 }} </td>
          </ng-container>
  
          <ng-container matColumnDef="total_sub8">
            <th mat-header-cell *matHeaderCellDef> Total Sub8 </th>
            <td mat-cell *matCellDef="let s"> {{ s.total_sub8 }} </td>
          </ng-container>
  
          <ng-container matColumnDef="result_sub8">
            <th mat-header-cell *matHeaderCellDef> Result Sub8 </th>
            <td mat-cell *matCellDef="let s"> {{ s.result_sub8 }} </td>
          </ng-container>
  
          <!-- Header and Row -->
          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
    </div>
    <mat-paginator
              [pageSizeOptions]="[5, 10, 15, 20]"
              [length]="pagination.length"
              [pageIndex]="pagination.page - 1"
              [pageSize]="pagination.limit"
              (page)="pageEvent($event)"
              *ngIf="pagination.length">
  </mat-paginator>
  </mat-card>